import React, { Component, Profiler } from "react"
import Axios from "axios"
import { CLOUD_FUNCTION } from "../../../../../config/fbConfig"

import { Row, Col, Icon, Card, Checkbox, message } from "antd";
import Changeplan from "../changeplan/changeplan";
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  watching = () => this.props.lastViewCourse.id? this.props.history.push(`/courses/${this.props.lastViewCourse.slug}`): message.error("You have not started watching any courses yet")
  render() {
    const { profile,firebase } = this.props
    var emailCheckCheck = {}
    if( profile.emailConfirmed) {
      emailCheckCheck.checked = true
    } 
    return (
      <div className="login-dashboard">
        {/* <div className="x-header">
          <h3>Welcome to Orsity</h3>
        </div>
        <Row>
          <Col xs="24" sm="24" md="12" lg="24">
            <div className="x-box">
              <div className="x-info">
                Try New Feature
              </div>
              <div className="x-content">
                <Icon type="" />
                <h4>Learning Paths</h4>
                <p>Start your journey in orsity and get clarity on what courses to take</p>
              </div>
            </div>
          </Col>
          <Col xs="24" sm="24" md="12" lg="24">
            <div className="x-box">
              <div className="x-info">
                Try New Feature
                            </div>
              <div className="x-content">
                <Icon type="" />
                <h4>Courses</h4>
                <p>Master every topic with our analytics Courses for everyone</p>
              </div>
            </div>
          </Col>
          <Col xs="24" sm="24" md="12" lg="24">
            <div className="x-box">
              <div className="x-info">
                Try New Feature
                            </div>
              <div className="x-content">
                <Icon type="" />
                <h4>Slack Community</h4>
                <p>Share your passion with other students like you</p>
              </div>
            </div>
          </Col>
        </Row> */}
        <Row className="main-row" gutter={14}>
          <Col lg={6} sm={24} md={9} className="dashboard-first">
            <Card>
              <Row className="user-info" gutter={8}>
                <Col lg={6} sm={6} xs={6}>
                  <img src="/img/user.png" alt={profile.fullName} className="profile-img" />
                </Col>
                <Col lg={18} sm={18} xs={18}>
                  <h6><b>{profile.fullName}</b></h6>
                  <p>Plan: {profile.plan}</p>
                </Col>
              </Row>
            </Card>
            <Card>
              <p className="check-list-heading">New to this platform? first steps:</p>
              <div className="check-lists">
                <div>
                  <Checkbox className={`${firebase.auth.emailVerified ? 'done' : ''}`  } disabled={firebase.auth.emailVerified} checked={firebase.auth.emailVerified}>Confirm email address</Checkbox>
                </div>
              </div>
              <div className="check-lists">
                <div>
                  <Checkbox  disabled={true} checked={false}>Update Profile</Checkbox>
                </div>
              </div>
              <div className="check-lists">
                <div>
                  <Checkbox  disabled={true} checked={false}>Update Profile pic</Checkbox>
                </div>
              </div>
              <div className="check-lists">
                <div>
                  <Checkbox  disabled={true} checked={false}>Start One Course</Checkbox>
                </div>
              </div>
            </Card>

          </Col>
          <Col lg={18} sm={24} md={15}>
             <h3 className="welcome-head">Hi {profile.firstName}, Welcome to Orsity</h3>
            <Row gutter={16}>
              <Col lg={8}>
                <div className="xheader-label">
                  Try new Feature
                  </div>
                <Card hoverable className="dashboard-item" onClick={() => this.props.history.push('/courses?show=mycourses')}>

                  <img src="/img/coursestart.png" alt="" />
                  <h4>My Playlist</h4>
                  <p>
                    We keep track of all the courses you have started.
                  </p>
                </Card>
              </Col>
              <Col lg={8}>
                <div className="xheader-label">
                  Try new Feature
                  </div>
                <Card hoverable className="dashboard-item" onClick={() => this.props.history.push('/courses')}>

                  <img src="/img/course.png" alt="" />
                  <h4>Courses</h4>
                  <p>
                    Master every topic with our Courses for everyone.
                  </p>
                </Card>
              </Col>
              <Col lg={8}>
                <div className="xheader-label">
                  Try new Feature
                  </div>
                <Card hoverable className="dashboard-item" onClick={this.watching}>
                  <img src="/img/approach.png" alt="" />
                  <h4>Watching</h4>
                  <p>
                    Pick up from where you left and continue your journey
                  </p>
                </Card>
              </Col>
              <Col lg={8}>
                {/* <div className="xheader-label">
                  Try new Feature
                  </div> */}
                <Card hoverable className="dashboard-item" onClick={() => this.props.history.push('/blog')}>
                  <img src="/img/blogone.png" alt="" />
                  <h4>Blog</h4>
                  <p>
                    Keep yourself updated with trending news and exciting ideas.
                  </p>
                </Card>
              </Col>
              <Col lg={8}>

                <Card hoverable className="dashboard-item" onClick={() => this.props.history.push('/settings')}>
                  <img src="/img/fix.png" alt="" />
                  <h4>Settings</h4>
                  <p>
                    Keep yourself updated with trending news and exciting ideas.
                  </p>
                </Card>
              </Col>
              {/* <Col lg={8}>
              
                 <Card hoverable className="dashboard-item" onClick={() => this.props.history.push('/change-plan')}>
                   <img src="/img/expensive.png" alt="" />
                   <h4>Upgrade your account</h4>
                   <p>
                     Keep yourself updated with trending news and exciting ideas.
                   </p>
                 </Card>
               </Col> */}
            </Row>
        {/* <Changeplan from="dashboard"/> */}

          </Col>

        </Row>
        {this.props.firebase.auth.email != "admin@gmail.com" &&
        <Changeplan from="dashboard" className="change-plans"/>}
        {/* <div className="amazing-feature">
          <div className="">
            <h2>Welcome to Orsity</h2>
            <div className="row" >
              <div className="col-xs-12 col-md-4" onClick={() => this.props.history.push('/courses')}>
                <div className="single-box float-right tran3s xcursor">
                  <i className="flaticon-compose"></i>
                  <h6><a href="#" className="tran3s">Courses</a></h6>
                  <p>Master every topic with our analytics Courses for everyone.</p>
                </div>
              </div>
              <div className="col-xs-12 col-md-4">
                <div className="single-box tran3s xcursor">
                  <i className="flaticon-light-bulb"></i>
                  <h6><a href="#" className="tran3s">Slack Community</a></h6>
                  <p>Share your passion with other students like you.</p>
                </div>
              </div>
              <div className="col-xs-12 col-md-4" onClick={() => this.props.history.push('/blog')}>
                <div className="single-box tran3s xcursor">
                  <i className="flaticon-light-bulb"></i>
                  <h6><a href="#" className="tran3s">Blog</a></h6>
                  <p>Keep yourself updated with trending news and exciting ideas.</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    )
  }

}

export default (Dashboard)